import React, { Component } from 'react'
import { object, func } from 'prop-types'

class WorkflowStepCheck extends Component {
  render () {
    const { completed, _id } = this.props.step
    if (completed) {
      return <div />
    } else {
      return (
        <div className='pull-right mt20'>
          <button className='btn btn-primary btn-sm' onClick={() => { this.props.submit(_id, 'check') }}>Concluir</button>
        </div>
      )
    }
  }
}

WorkflowStepCheck.propTypes = {
  step: object,
  submit: func
}

export default WorkflowStepCheck



// WEBPACK FOOTER //
// ./src/components/WorkflowStepCheck.js